interface OfferingLink {
  listText?: string;
  hrefText?: string;
}
 
const ListLinks = ({ links }: { links: OfferingLink[] }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 rounded-[20px] p-[30px] bg-[var(--bs-body-bg-grey)]">
    {links.map(({ listText, hrefText }, i) => (
      <div key={i} className="!mt-4 lg:mt-0 !pl-2 lg:pl-0 !pr-2 lg:pr-0">
        <a
          href={hrefText || "#"}
          target="_blank"
          className="relative group flex flex-row items-center gap-[12px] p-[20px] pl-[23px] flex-1 rounded-[12px] bg-white no-underline transition-all duration-1000 ease-in-out"
        >
          <div className="relative w-[32px] h-[32px]">
            <img
              src="/images/icons/icon-list-gray.svg"
              alt="List icon gray"
              className="absolute inset-0 transition-opacity duration-300 group-hover:opacity-0"
            />
            <img
              src="/images/icons/icon-list-green.svg"
              alt="List icon green"
              className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            />
          </div>
          <span className="mt-[0.3rem]">{listText || "Untitled"}</span>
        </a>
      </div>
    ))}
  </div>
);

export default ListLinks;
